import { useQuery } from '@tanstack/react-query';

import { fetchXmrQuote, writePriceCache } from '@/lib/prices';

/**
 * Live XMR quote: refetches every 60s, falls back through
 * Kraken -> CoinGecko -> localStorage cache, persists successful
 * non-cache quotes back to storage.
 */
export function useXmrPrice() {
  return useQuery({
    queryKey: ['stashstr', 'xmr-price'],
    queryFn: async (c) => {
      const quote = await fetchXmrQuote(c.signal);
      if (quote.source !== 'cache') {
        writePriceCache(quote);
      }
      return quote;
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    gcTime: 30 * 60_000,
  });
}
